import { Converter } from '../types/converter';

export const electricPotentialConverter: Converter = {
  id: 'electricPotential',
  name: 'Electric Potential Converter',
  icon: 'Zap',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Volt', symbol: 'V', factor: 1 },
    
    // Alternative expressions
    { name: 'Watt/ampere', symbol: 'W/A', factor: 1 },
    
    // CGS units
    { name: 'Abvolt', symbol: 'abV', factor: 1e-8 },
    { name: 'EMU of electric potential', symbol: 'EMU', factor: 1e-8 },
    { name: 'Statvolt', symbol: 'stV', factor: 299.792458 }
  ]
};
